import React from 'react';
import ReactLoading from 'react-loading';
import useTheme from '../../utils/styles/theme/useTheme';

export default function LoadingCircle() {
  const { colors } = useTheme();
  return <ReactLoading type={'spin'} color={colors.primary.primary} />;
}
